import { render, staticRenderFns } from "./ModalReciboParcial.vue?vue&type=template&id=dd33f1ca"
import script from "./ModalReciboParcial.vue?vue&type=script&lang=js"
export * from "./ModalReciboParcial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports